import { SkeletonButton, SkeletonCard, SkeletonText } from "../UI/loaders/CommonSkeleton";

const OrderDetailsSkeleton = () => {
    return (
        <div className="p-6">
            {/* Header */}
            <div className="mb-6 flex items-center justify-end gap-3">
                <SkeletonButton width="w-32" />
                <SkeletonText width="w-32" height="h-6" />
                <SkeletonButton width="w-8" height="h-8" />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Customer Information Card */}
                <SkeletonCard>
                    <SkeletonText width="w-48" height="h-6" className="mb-6" />

                    <div className="space-y-4">
                        {/* First Name & Last Name Row */}
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <SkeletonText width="w-24" height="h-4" className="mb-2" />
                                <SkeletonText width="w-32" height="h-5" />
                            </div>
                            <div>
                                <SkeletonText width="w-24" height="h-4" className="mb-2" />
                                <SkeletonText width="w-16" height="h-5" />
                            </div>
                        </div>

                        {/* Email & Phone Row */}
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <SkeletonText width="w-16" height="h-4" className="mb-2" />
                                <SkeletonText width="w-48" height="h-5" />
                            </div>
                            <div>
                                <SkeletonText width="w-28" height="h-4" className="mb-2" />
                                <SkeletonText width="w-36" height="h-5" />
                            </div>
                        </div>

                        {/* Device Type */}
                        <div>
                            <SkeletonText width="w-24" height="h-4" className="mb-2" />
                            <SkeletonText width="w-20" height="h-5" />
                        </div>
                    </div>
                </SkeletonCard>

                {/* Order Summary Card */}
                <SkeletonCard>
                    <SkeletonText width="w-40" height="h-6" className="mb-6" />

                    <div className="space-y-4">
                        {/* Order ID & Total Row */}
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <SkeletonText width="w-20" height="h-4" className="mb-2" />
                                <SkeletonText width="w-32" height="h-5" />
                            </div>
                            <div>
                                <SkeletonText width="w-16" height="h-4" className="mb-2" />
                                <SkeletonText width="w-24" height="h-5" />
                            </div>
                        </div>

                        {/* Order Status & Payment Wallet Row */}
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <SkeletonText width="w-24" height="h-4" className="mb-2" />
                                <SkeletonText width="w-20" height="h-5" />
                            </div>
                            <div>
                                <SkeletonText width="w-36" height="h-4" className="mb-2" />
                                <SkeletonText width="w-24" height="h-5" />
                            </div>
                        </div>

                        {/* Payment Status & Grand Total Row */}
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <SkeletonText width="w-32" height="h-4" className="mb-2" />
                                <SkeletonText width="w-20" height="h-5" />
                            </div>
                            <div>
                                <SkeletonText width="w-24" height="h-4" className="mb-2" />
                                <SkeletonText width="w-24" height="h-5" />
                            </div>
                        </div>

                        {/* Order Date & Discounted Price Row */}
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <SkeletonText width="w-32" height="h-4" className="mb-2" />
                                <SkeletonText width="w-40" height="h-5" />
                            </div>
                            <div>
                                <SkeletonText width="w-36" height="h-4" className="mb-2" />
                                <SkeletonText width="w-24" height="h-5" />
                            </div>
                        </div>

                        {/* Payment Type & Transaction ID Row */}
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <SkeletonText width="w-28" height="h-4" className="mb-2" />
                                <SkeletonText width="w-32" height="h-5" />
                            </div>
                            <div>
                                <SkeletonText width="w-32" height="h-4" className="mb-2" />
                                <SkeletonText width="w-28" height="h-5" />
                            </div>
                        </div>

                        {/* Loyalty Points */}
                        <div>
                            <SkeletonText width="w-28" height="h-4" className="mb-2" />
                            <SkeletonText width="w-16" height="h-5" />
                        </div>
                    </div>
                </SkeletonCard>
            </div>

            {/* Delivery Information Card */}
            <SkeletonCard className="mt-6">
                <SkeletonText width="w-44" height="h-6" className="mb-6" />

                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <SkeletonText width="w-28" height="h-4" className="mb-2" />
                        <SkeletonText width="w-40" height="h-5" />
                    </div>
                    <div>
                        <SkeletonText width="w-36" height="h-4" className="mb-2" />
                        <SkeletonText width="w-24" height="h-5" />
                    </div>
                </div>
            </SkeletonCard>
        </div>
    );
};

export default OrderDetailsSkeleton;